"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../data/store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    selectedLocale: function () { return store_1.default().selectedLocale; },
    selectedDateFormat: function () { return store_1.default().selectedDateFormat; },
    selectedTimeFormat: function () { return store_1.default().selectedTimeFormat; },
    selectedTimeZone: function () { return store_1.default().selectedTimeZone; },
    savedLocale: function () { return owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture; },
    savedDateFormat: function () { return owa_session_store_1.getUserConfiguration().UserOptions.DateFormat; },
    savedTimeFormat: function () { return owa_session_store_1.getUserConfiguration().UserOptions.TimeFormat; },
    savedTimeZone: function () { return owa_session_store_1.getUserConfiguration().UserOptions.TimeZone; },
})(function isRegionalOptionDirty(state) {
    var selectedLocale = state.selectedLocale, selectedDateFormat = state.selectedDateFormat, selectedTimeFormat = state.selectedTimeFormat, selectedTimeZone = state.selectedTimeZone, savedLocale = state.savedLocale, savedDateFormat = state.savedDateFormat, savedTimeFormat = state.savedTimeFormat, savedTimeZone = state.savedTimeZone;
    return ((selectedLocale !== null && selectedLocale !== savedLocale) ||
        (selectedDateFormat !== null && selectedDateFormat !== savedDateFormat) ||
        (selectedTimeFormat !== null && selectedTimeFormat !== savedTimeFormat) ||
        (selectedTimeZone !== null && selectedTimeZone !== savedTimeZone));
});
//# sourceMappingURL=isRegionalOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/utils/isRegionalOptionDirty.js
// module id = 4944
// module chunks = 2